import lodashGet from 'lodash/get';
/**
 * Sets the origin (default) label for each correlation, e.g. C1 or H2, depending on its order.
 *
 * @param {Values} values
 */
export function setLabels(correlations) {
    const atomTypeCounts = {};
    correlations.forEach((correlation) => {
        if (!lodashGet(atomTypeCounts, correlation.atomType, false)) {
            atomTypeCounts[correlation.atomType] = 0;
        }
        atomTypeCounts[correlation.atomType]++;
        correlation.label.origin = `${correlation.atomType}${atomTypeCounts[correlation.atomType]}`;
    });
    return correlations;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2V0TGFiZWxzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3V0aWxpdGllcy9idWlsZC9zZXRMYWJlbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxTQUFTLE1BQU0sWUFBWSxDQUFDO0FBS25DOzs7O0dBSUc7QUFDSCxNQUFNLFVBQVUsU0FBUyxDQUFDLFlBQW9CO0lBQzVDLE1BQU0sY0FBYyxHQUFtQyxFQUFFLENBQUM7SUFDMUQsWUFBWSxDQUFDLE9BQU8sQ0FBQyxDQUFDLFdBQVcsRUFBRSxFQUFFO1FBQ25DLElBQUksQ0FBQyxTQUFTLENBQUMsY0FBYyxFQUFFLFdBQVcsQ0FBQyxRQUFRLEVBQUUsS0FBSyxDQUFDLEVBQUU7WUFDM0QsY0FBYyxDQUFDLFdBQVcsQ0FBQyxRQUFRLENBQUMsR0FBRyxDQUFDLENBQUM7U0FDMUM7UUFDRCxjQUFjLENBQUMsV0FBVyxDQUFDLFFBQVEsQ0FBQyxFQUFFLENBQUM7UUFDdkMsV0FBVyxDQUFDLEtBQUssQ0FBQyxNQUFNLEdBQUcsR0FBRyxXQUFXLENBQUMsUUFBUSxHQUNoRCxjQUFjLENBQUMsV0FBVyxDQUFDLFFBQVEsQ0FDckMsRUFBRSxDQUFDO0lBQ0wsQ0FBQyxDQUFDLENBQUM7SUFFSCxPQUFPLFlBQVksQ0FBQztBQUN0QixDQUFDIn0=